import React, { useState, useEffect, useRef, useCallback } from 'react';
import 'devextreme/data/odata/store';
import DataGrid, {
  Column,
  Paging,
  FilterRow,
  Editing,
  Texts,
  Button,
  Form,
  HeaderFilter,
  SearchPanel,
  RequiredRule,
  Popup,
  FilterPanel
} from 'devextreme-react/data-grid';
import { Item } from 'devextreme-react/form';
import { useHistory } from "react-router";
import EntityService from "../../api/entity.service";
import Toast from 'components/Toast';
import {Tooltip} from 'devextreme-react';
import {LoadPanel as LoadingPanel} from 'devextreme-react/load-panel';
import SlidingDrawer from 'components/sliding-drawer/SlidingDrawer';
import TextBox from 'devextreme-react/text-box';
import {
  Form as DxForm,
  SimpleItem,
  GroupItem,
  Label,
  RequiredRule as DxFormRequiredRules
} from 'devextreme-react/form';
// import {
//   Button as SelectButton
// } from 'devextreme-react';

export default function App() {
  const [data, setData] = useState([])
  const [loadingText, setloadingText] = useState('Loading...');
  const [loading, setLoading] = useState(false);
  const [toastConfig, setToastConfig] = React.useState({
    isVisible: false,
    type: 'info',
    message: '',
    displayTime: 5000
  });
  const history = useHistory();
  const dropDataGridRef = useRef()
  const [isDisabled, setIsDisabled] = useState(true)
  const [isOpen, setIsOpen] = useState(false);
  const [editingRow, setEditingRow] = useState(null);
  const formRef = useRef();
  const dxFormRef = useRef();
  const [formData, setFormData] = useState({
    id: null,
    name: ''
  });
  const [prevData, setPrevData] = useState(null)

  function getData() {
    EntityService.getTenantEntityGroup().then((value) => {
      console.log("âš ï¸ Response data:", value.data.data);

      setData(value.data.data)
      if (value.data.data.length === 0){
        setloadingText("No Data")
      }
    })
  }

  // function onRowInserted(e) {
  //   setLoading(true);
  //   EntityService.createEntityGroup(e.data.name).then((res) => {
  //     const insertedData = res.data.data; 
  //     console.log('INSERTED DATAE: ', insertedData);
      
  //     if (insertedData && typeof insertedData === 'object' && insertedData.id && insertedData.name) {
  //       Object.assign(e.data, insertedData);
  //     } else {
  //       console.error('Unexpected response format:', insertedData);
  //     }

  //     setToastConfig({
  //       ...toastConfig,
  //       isVisible: true,
  //       type: res.status===200 ? 'success' : 'error',
  //       status: res?.data?.status ? res.data.status : res?.status,
  //       message: res?.data?.message ? res.data.message : res?.message,
  //     });
  //   }).finally(() => {
  //     setLoading(false);
  //     getData();
  //     // window.location.reload();
  //   });
  // }

  function onRowInserted(e) {
    setLoading(true);
  
    EntityService.createEntityGroup(e.data.name)
      .then((res) => {
        const insertedData = res?.data?.data;
  
        if (insertedData && typeof insertedData === 'object') {
          // Replace each expected field explicitly
          e.data.id = insertedData.id;
          e.data.name = insertedData.name;
        } else {
          console.error("Returned data is not a valid object:", insertedData);
        }
  
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: 'success',
          message: 'Behavior added successfully',
        });
  
        history.push({
          pathname: `/behaviors/${insertedData.id}`,
          state3: { response: "" },
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setLoading(false));
  }

  function onRowRemoved(e) {
    setLoading(true);
    EntityService.deleteEntityGroup(e.data.id).then((res) => {
      setToastConfig({
        ...toastConfig,
        isVisible: true,
        type: res.status===200 ? 'success' : 'error',
        status: res?.data?.status ? res.data.status : res?.status,
        message: res?.data?.message ? res.data.message : res?.message,
      });
      getData()
    }).finally(() => {
      setLoading(false);
    });
  }

  // function onRowUpdating(e) {
  //     setLoading(true);
  //     EntityService.editEntityGroup(e.newData.name, e.oldData.id).then((res) => {
  //       getData()
  //       setToastConfig({
  //         ...toastConfig,
  //         isVisible: true,
  //         type: res.status===200 ? 'success' : 'error',
  //         status: res?.data?.status ? res.data.status : res?.status,
  //         message: res?.data?.message ? res.data.message : res?.message,
  //       });
  //     }).finally(() => {
  //       setLoading(false);
  //     });
  // }

  function buttonColor(e) {
    if (((e.column.caption === 'Entities') || (e.column.caption === 'Entities/Rules')) && e.rowType !== "header") {
      e.cellElement.style.color = "#ffc72c";
      e.cellElement.style.setProperty('cursor', 'pointer', 'important')
    }

    
    if ((e?.column?.dataField === 'name') && e?.rowType !== "header") {
      e.cellElement.style.color = "#337ab7";
      e.cellElement.style.setProperty('cursor', 'pointer', 'important')
    }
    
  }

  function showInfo(e) {
    // if (e.column.caption === 'Entities/Rules') {
    //   e.cellElement.style.color = "#337ab7";
    //   history.push({
    //     pathname: `/behaviors/${e.data.id}`,
    //     state3: {
    //       response: ""
    //     }
    //   })
    // } else if (e.column.caption === 'Rules') {
    //   e.cellElement.style.color = "#337ab7";
    //   history.push({
    //     pathname: `/behaviors/rule/${e.data.id}`,
    //     state3: {
    //       response: ""
    //     }
    //   })
    // }
    
      if (e.data){
        if (e.column.name === 'name') {
          e.cellElement.style.color = "#337ab7";
          history.push({
            pathname: `/behaviors/${e.data.id}`,
            state3: {
              response: ""
            }
          })
        }
      }
  }

  // function entitiesText() {
  //   return (
  //     <>
  //       Edit
  //     </>
  //   )
  // }

  // function rulesText() {
  //   return (
  //     <>
  //       Edit
  //     </>
  //   )
  // }

  function handleCloseDrawer(){
    setEditingRow(null)
    setIsOpen(false)
    // Reset form data when drawer is closed
    setFormData({
      id: null,
      name: ''
    })
  }

  function onAddRow(e) {
    setLoading(true);
    EntityService.createEntityGroup(formData?.name)
      .then((res) => {
        const insertedData = res?.data?.data;
        getData()
  
        // if (insertedData && typeof insertedData === 'object') {
        //   // Replace each expected field explicitly
        //   e.data.id = insertedData.id;
        //   e.data.name = insertedData.name;
        // } else {
        //   console.error("Returned data is not a valid object:", insertedData);
        // }
  
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: 'success',
          message: 'Behavior added successfully',
        });
        history.push({
          pathname: `/behaviors/${insertedData.id}`,
          state3: { response: "" },
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setLoading(false));
  }

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    const result = dxFormRef.current?.validate?.();
    if (result?.isValid) {
      onAddRow()
      handleCloseDrawer();
    }
  },[formData, handleCloseDrawer]);

  function handleSave(){
    formRef.current?.requestSubmit();
    // console.log("edited:", editingRow)
    // setIsOpen(false)
  }

  function onSubmit(data){
    console.log("edited:", editingRow)
    setEditingRow(null)
    setIsOpen(false)
  }

  function handleInputChange(e, name) {
    const value = name === "name" ? e?.value : e?.selectedItem;
    if (!value) return;

    setEditingRow(prev => ({
      ...prev,
      [name]: value
    }));
  }


  useEffect(() => {
    getData()
  }, []);

  return (
    <>
    
    <div className='headerHeadingPage'>
		  <div className='pageFullWidthEvents'>
        <h5 className='marginZeroEvents'>
          <b>Behaviors</b>
        </h5>
      <DataGrid
        noDataText={loadingText}
        ref={dropDataGridRef}
        showColumnLines={false}
        showRowLines={true}
        onRowInserted={onRowInserted}
        onRowRemoved={onRowRemoved}
        // onRowUpdating={onRowUpdating}
        onCellClick={showInfo}
        allowColumnResizing={true}
        onCellPrepared={buttonColor}
        height={'calc(100vh - 102px)'}
        // onEditingStart={handleEditingStart}
        onColumnsChanging={function (e) {
          if(e.component?.getDataSource()?._totalCount <= 0 && data.length > 0){
            setloadingText('No Data');
          }
        }}
        onToolbarPreparing={(e) => {
          const addButtonIndex = e.toolbarOptions.items.findIndex(item => item.name === 'addRowButton');
        
          if (addButtonIndex !== -1) {
            const addButton = e.toolbarOptions.items[addButtonIndex];

            addButton.widget = 'dxButton';
            addButton.options = {
              ...addButton.options,
              elementAttr: { id: 'addTenantButton' },
              icon: '',
              text: '',
              stylingMode: 'text',
              onClick: () => {
                setFormData({
                  id: null,
                  name: ''
                })
                setIsOpen(true)
              },
              template: (buttonData, buttonElement) => {
                const container = document.createElement('div');
                container.style.display = 'flex';
                container.style.alignItems = 'center';
                container.style.justifyContent = 'center';
        
                container.innerHTML = `
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                       viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                       stroke-linecap="round" stroke-linejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19" />
                    <line x1="5" y1="12" x2="19" y2="12" />
                  </svg>
                `;
                container.style.color = 'var(--app-text)';
                buttonElement.appendChild(container);
              }
            };
          }
        }}
        
        dataSource={data}>
        <FilterPanel visible={true} texts={{createFilter: '', clearFilter:'Clear Filter', filterEnabledHint: ''}}/>
        <Paging enabled={false} />
        <Editing
          allowUpdating={false}
          allowDeleting={true}
          allowAdding={true}
          use-icons={true}
          // mode="popup"
          texts={{
            // addRow: 'Add Behavior',
            confirmDeleteMessage:"Are you sure you want to delete this Behavior?"
          }}
        >
          {/* <Popup
            showTitle={true}
            width={500}
            maxHeight={800}
            title="Behavior"
          /> */}
          {/* <Form colCount={1}>
            <Item dataField="name" />
          </Form> */}
        </Editing>
        <FilterRow visible="true" apply-filter="true" />
        <HeaderFilter visible="showHeaderFilter" />
        <SearchPanel visible="true" width="240" placeholder="Search..." />
        
        <Column
          dataField={'name'}
          caption={"Behavior Name"}
          hidingPriority={8}
        >
          <RequiredRule />
        </Column>
        {/* <Column
          caption={'Entities'}
          width={100}
          cellRender={entitiesText}
        ></Column> */}
        {/* <Column
          caption={'Entities/Rules'}
          // width={100}
          cellRender={rulesText}
        ></Column> */}
        <Column type="buttons" width={110} key={'actionUpdateButtons'}>
          <Button name="edit" />
          <Button name="delete" />
        </Column>
      </DataGrid>
      <Tooltip
        target="#addTenantButton"
        showEvent="mouseenter"
        hideEvent="mouseleave"
        position="bottom"
      >
        <div className="custom-tooltip">Add a Behavior</div>
      </Tooltip>
      <Toast
        setParentToastConfig={setToastConfig}
        toastBody={toastConfig}
      />
      <LoadingPanel
        shadingColor="rgba(34, 31, 31, 0.4)"
        visible={loading}
        showIndicator={true}
        showPane={true}
        shading={true}
        hideOnOutsideClick={false}
      />
      </div>
      </div>

      <SlidingDrawer 
          title={`Behavior`}
          isOpen={isOpen} 
          onClose={handleCloseDrawer}
          handleSave={handleSave}
          formData={formData}
          prevData={prevData} 
        >
          {isOpen &&
          <form ref={formRef} onSubmit={handleSubmit}>
            <div>
              <DxForm
                formData={formData}
                onFieldDataChanged={(e) => {
                  setFormData((prev) => ({
                    ...prev,
                    [e.dataField]: e.value,
                  }));
                }}
                onInitialized={(e) => {
                  dxFormRef.current = e.component;
                }}
                labelLocation="top"
                showColonAfterLabel={false}
                showValidationSummary={false}
              >
                <GroupItem colCount={1}>
                  <SimpleItem
                    dataField="name"
                    editorType="dxTextBox"
                    editorOptions={{
                      valueChangeEvent: 'input',
                    }}
                    validationRules={[{ type: 'required', message: 'Behavior Name is required' }]}
                  >
                    <Label text="Behavior Name" isRequired />
                  </SimpleItem>
                </GroupItem>
              </DxForm>
            </div>
          </form>
          }
      </SlidingDrawer>
    </>
  );
}